/**
 * external libs
 */
import React, {useContext} from 'react'
/**
 * components
 */
import Widget from "../../../../Widget";
import Avatar from "../../../../Avatar";
/**
 * external libs
 */
import styles from './index.module.scss'
import WidgetString from "../../../../Widget/components/WidgetString";
import {AlertContext} from "../../../../../pages/context/alert.context";
import {useTranslation} from "react-i18next";
import nameString from "../../../../../utils/nameString";

export default function UserItem({ copy = true, firstNameResult, middleNameResult, lastNameResult }){
    const {setAlertSuccess, setAlertError} = useContext(AlertContext)
    const {t} = useTranslation()


    const copyText = (e, text) => {
        e.preventDefault();
        e.stopPropagation();

        navigator.clipboard.writeText(text).then(function() {
            setAlertSuccess(t("Copied"))
        }, function(err) {
            setAlertError('Could not copy text: ', err);
        });
    };

    return (
        <div className={styles.user}>
            <div className={styles.user__info}>
                <div style={{display: "flex", gap: 4, alignItems: "center"}}>
                    {lastNameResult && (
                        <Widget result={lastNameResult}/>
                    )}
                    {" "}
                    {firstNameResult && (
                        <Widget result={firstNameResult}/>
                    )}
                    {" "}
                    {middleNameResult && (
                        <Widget result={middleNameResult}/>
                    )}
                    {copy && (
                        <div className={styles.user__copy_wrapper} onClick={e => copyText(e, nameString(lastNameResult?.measures, firstNameResult?.measures, middleNameResult?.measures))}>
                            <div className={styles.user__copy}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M19 4H1C0.73478 4 0.48043 4.1054 0.29289 4.2929C0.10536 4.4804 0 4.7348 0 5V23C0 23.2652 0.10536 23.5196 0.29289 23.7071C0.48043 23.8946 0.73478 24 1 24H19C19.2652 24 19.5196 23.8946 19.7071 23.7071C19.8946 23.5196 20 23.2652 20 23V5C20 4.7348 19.8946 4.4804 19.7071 4.2929C19.5196 4.1054 19.2652 4 19 4ZM18 22H2V6H18V22ZM24 1V19C24 19.2652 23.8946 19.5196 23.7071 19.7071C23.5196 19.8946 23.2652 20 23 20C22.7348 20 22.4804 19.8946 22.2929 19.7071C22.1054 19.5196 22 19.2652 22 19V2H5C4.7348 2 4.4804 1.89464 4.2929 1.70711C4.1054 1.51957 4 1.26522 4 1C4 0.73478 4.1054 0.48043 4.2929 0.29289C4.4804 0.10536 4.7348 0 5 0H23C23.2652 0 23.5196 0.10536 23.7071 0.29289C23.8946 0.48043 24 0.73478 24 1Z" fill="#323238"/>
                                </svg>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}
